import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=507d7148&scoped=true&"
import script from "./SplitView.vue?vue&type=script&lang=js&"
export * from "./SplitView.vue?vue&type=script&lang=js&"
import style0 from "./SplitView.vue?vue&type=style&index=0&id=507d7148&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d7148",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
